/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { MinorSelectionValues } from './minorSelectionModal-ng.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'minor-selection-modal',
    standalone: false,
})
export class MinorSelectionModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Input() resolve: MinorSelectionValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('minorSelectionModal', elementRef, injector);
    }
}
